const { REACT_APP_ENABLE_SEARCH_FILTER } = process.env;

const isSearchFilterEnabled =
  REACT_APP_ENABLE_SEARCH_FILTER?.toLowerCase() === 'false' ? false : true;

export default isSearchFilterEnabled;
